import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doPostFiles } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getObjectiveGoal = (id) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal`
  return doGet(url)
}

export const getGoal = (id) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/goals`
  return doGet(url)
}

export const saveGoal = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/goals`
  return doPost(url, request)
}

export const updateGoal = (id, goalId, request) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/goals/${goalId}`
  return doPut(url, request)
}

export const deleteGoal = (id, goalId) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/goals/${goalId}`
  return doDelete(url)
}

export const getObjective = (id) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/objective`
  return doGet(url)
}

export const saveObjective = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/objective`
  return doPost(url, request)
}

export const updateObjective = (id, objectiveId, request) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/objective/${objectiveId}`
  return doPut(url, request)
}

export const deleteObjective = (id, objectiveId) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/objective/${objectiveId}`
  return doDelete(url)
}

export const getIndicators = (id) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/indicators`
  return doGet(url)
}
export const saveIndicators = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/indicators`
  return doPost(url, request)
}

export const updateIndicators = (id, indicatorsId, request) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/indicators/${indicatorsId}`
  return doPut(url, request)
}

export const deleteIndicators = (id, indicatorsId) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/indicators/${indicatorsId}`
  return doDelete(url)
}

export const getLinkageIndicators = (projectVersionId, projectIndicatorId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/objective-goal/project-linkage-indicator/${projectIndicatorId}`
  return doGet(url)
}

export const saveLinkageIndicators = (request, projectVersionId, projectIndicatorId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/objective-goal/project-linkage-indicator/${projectIndicatorId}`
  return doPut(url, request)
}

export const getOutcomeIndicator = (projectVersionId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/review/outcome-indicator`
  return doGet(url)
}

export const getProjectPlan5Year = (projectVersionId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/review/outcome-indicator/project-plan-5-year`
  return doGet(url)
}

export const saveProjectPlan5Year = (request, projectVersionId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/review/outcome-indicator/project-plan-5-year`
  return doPut(url, request)
}

//----------กรอบแนวคิดและยุทธศาสตร์(Conceptual framework)------------
export const getConceptual = (id) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/conceptual`
  return doGet(url)
}

export const saveConceptual = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/conceptual`
  return doPost(url, request)
}

export const updateConceptual = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/conceptual/${request.id}`
  return doPut(url, request)
}

export const deleteConceptual = (id, conceptualId) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/conceptual/${conceptualId}`
  return doDelete(url)
}

//----------แผนดำเนินงาน/(ระเบียบวิธีการวิจัย)------------
export const getActionPlan = (id) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/actionPlan`
  return doGet(url)
}

export const saveActionPlan = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/actionPlan`
  return doPost(url, request)
}

export const updateActionPlan = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/actionPlan/${id}`
  return doPut(url, request)
}

export const uploadFilesActionPlan = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/actionplan/attachments`
  return doPostFiles(url, request)
}

export const deleteFilesActionPlan = (id, fileId) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/actionplan/attachments/${fileId}`
  return doDelete(url)
}

export const getFilesActionPlan = (id) => {
  const url = `${API_ROOT}/proposal/${id}/objective-goal/actionplan/attachments`
  return doGet(url)
}

export const changeAttachmentActionPlanSeqNo = (projectVersionId, fileId, seqNo) => {
  // /api/proposal/{projectVersionId}/objective-goal/actionplan/attachments/{fileId}/{seqNo}
  const url = `${API_ROOT}/proposal/${projectVersionId}/objective-goal/actionplan/attachments/${fileId}/${seqNo}`
  return doPut(url)
}

// --------------------------------------- subproject

export const getSubProjectObjectiveGoal = (id) => {
  // /api/subproject/{projectVersionId}/objective-goal
  const url = `${API_ROOT}/subproject/${id}/objective-goal`
  return doGet(url)
}

export const getSubProjectIndicators = (id) => {
  // ​/api​/subproject​/{projectVersionId}​/objective-goal​/indicators
  const url = `${API_ROOT}/subproject/${id}/objective-goal/indicators`
  return doGet(url)
}

export const updateSubProjectObjective = (id, objectiveId, request) => {
  // /api/subproject/{projectVersionId}/objective-goal/objective/{objectiveId}
  const url = `${API_ROOT}/subproject/${id}/objective-goal/objective/${objectiveId}`
  return doPut(url, request)
}

export const saveSubProjectObjective = (id, request) => {
  // ​ /api/subproject/{projectVersionId}/objective-goal/objective
  const url = `${API_ROOT}/subproject/${id}/objective-goal/objective`

  return doPost(url, request)
}

export const deleteSubProjectObjective = (id, objectiveId) => {
  // ​/api​/subproject​/{projectVersionId}​/objective-goal​/objective​/{objectiveId}
  const url = `${API_ROOT}/subproject/${id}/objective-goal/objective/${objectiveId}`
  return doDelete(url)
}

export const getSubProjectObjective = (id) => {
  // /api/subproject/{projectVersionId}/objective-goal/objective
  const url = `${API_ROOT}/subproject/${id}/objective-goal/objective`
  return doGet(url)
}

export const saveSubProjectIndicators = (id, request) => {
  // /api/subproject/{projectVersionId}/objective-goal/indicators
  const url = `${API_ROOT}/subproject/${id}/objective-goal/indicators`
  return doPost(url, request)
}

export const updateSubProjectIndicators = (id, indicatorsId, request) => {
  // /api/subproject/{projectVersionId}/objective-goal/indicators/{outcomeId}
  const url = `${API_ROOT}/subproject/${id}/objective-goal/indicators/${indicatorsId}`
  return doPut(url, request)
}

export const deleteSubProjectIndicators = (id, indicatorsId) => {
  // ​/api​/subproject​/{projectVersionId}​/objective-goal​/indicators​/{outcomeId}
  const url = `${API_ROOT}/subproject/${id}/objective-goal/indicators/${indicatorsId}`
  return doDelete(url)
}

// --------------------------------------- subproject
